export default __webpack_public_path__ + "static/media/notflixMain.f5decc10.png";